/* @flow */

import Company from 'models/companies/company';

export default class InvoiceFilters {
  statusKeys: string[];

  sellerCompanies: Company[];

  invoiceMaxAmount : ?number;
  invoiceMinAmount : ?number;

  constructor() {
    this.statusKeys = [];
    this.sellerCompanies = [];
    this.invoiceMaxAmount = null;
    this.invoiceMinAmount = null;
  }
}
